import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    title: 'Invoice n°{fiscalId}',
    unlink: 'Unlink invoice',
  },
  fr: {
    title: 'Facture n°{fiscalId}',
    unlink: 'Dissocier la facture',
  },
} as const);

export default locales;
